export default __webpack_public_path__ + "static/layout-anatomy-dark-61325f11648144824a13670f1e7bee0354e48a6e37fd83bdb23d301b337fa4dd.png";